import { combineReducers } from 'redux'

const snsReducer = (state = null, action) => {
    switch (action.type) {
        case "BEFORE_PACK_EXPIRY":
            let pack = action.payload

            return {
                ...state,
                pack: pack,
            }
        case "GET_ALL_USE_CASE":
            let allpack = action.payload

            return {
                ...state,
                allpack: allpack,
            }
        case "GET_ALL_CRITERIA":
            let allCriteria = action.payload

            return {
                ...state,
                allCriteria: allCriteria.map((res=>{
                    return res.criteria
                }))
            }
        case "GET_SUB_CRITERIA_OPERATOR":
            let criteriaOperator = action.payload

            return {
                ...state,
                criteriaOperator: criteriaOperator
            }
        case "GET_SUB_CRITERIA_AND_OPERATOR":
            let criteriaAndOperator = action.payload

            return {
                ...state,
                criteriaAndOperator: criteriaAndOperator
            }
            case "GET_SUB_CRITERIA_OPERATOR2":
                let criteriaOperator2 = action.payload
    
                return {
                    ...state,
                    criteriaOperator2: criteriaOperator2
                }
            case "GET_SUB_CRITERIA_AND_OPERATOR2":
                let criteriaAndOperator2 = action.payload
    
                return {
                    ...state,
                    criteriaAndOperator2: criteriaAndOperator2
                }
        default: return state
    }
}

const rootReducer = combineReducers({
    sns: snsReducer
});

export default rootReducer;